<template>
  <div class="">
    <div class="BG">
      <div class="Header Globalcontainer">
        <ul>
          <li>
            <div>{{ MsgNumList.WebVisitsNum }}<span>次</span></div>
            <span>平台访问量</span>
            <br />
            <img src="../assets/Map/1(1).png" alt="" />
          </li>
          <li>
            <div>{{ MsgNumList.ActivityNum }}+</div>
            <span>活动数量</span>
            <br />
            <img src="../assets/Map/1(2).png" alt="" />
          </li>
          <li>
            <div>{{ MsgNumList.ActivityUser }}+</div>
            <span>线上参会人数</span>
            <br />
            <img src="../assets/Map/1(3).png" alt="" />
          </li>
          <li>
            <div>{{ MsgNumList.UserNum }}<span>个</span></div>
            <span>注册用户量</span>
            <br />
            <img src="../assets/Map/1(4).png" alt="" />
          </li>
        </ul>
        <div class="manType">
          <p>注册 用户 类型</p>
          <div class="TypeBox">
            <div style="margin-top: 0">
              高校 <strong>{{ AllDataNum[0].r }}</strong>
            </div>
            <div style="margin-top: 0; margin-left: 10px">
              科技型企业 <strong>{{ AllDataNum[1].r }}</strong>
            </div>
            <div>
              高新技术企业 <strong>{{ AllDataNum[2].r }}</strong>
            </div>
            <div style="margin-left: 10px">
              科研机构<strong>{{ AllDataNum[3].r }}</strong>
            </div>
            <div style="width: 92%">
              其他
              <strong>{{
                MsgNumList.UserNum -
                AllDataNum[0].r -
                AllDataNum[1].r -
                AllDataNum[2].r -
                AllDataNum[3].r
              }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="TheMap">
        <h3>地图分布</h3>
        <p>MAP DISTRIBUTION</p>
        <div style="margin-top: 3.125rem;">
          <div
            @click="changeMapActive(0)"
            :class="MapActive == 0 ? 'NowMapAct' : ''"
            class="China" style="cursor: pointer;"
          >
            全国创新资源分布
          </div>
          <div
            @click="changeMapActive(1)"
            :class="MapActive == 1 ? 'NowMapActs' : ''"
            class="HeNan" style="cursor: pointer;"
          >
            河南创新资源分布
          </div>
        </div>
      </div>
    </div>
    <div class="Map" style="margin-top: 3.125rem;">
      <china-map v-if="MapActive == 0"></china-map>
      <HeNanMap ref="StopInter" v-if="MapActive == 1" />
    </div>
    <div>
      <div class="TheData">
        <h3>数据统计</h3>
        <p>DATA STATISTICS</p>
        <!-- 数据上 -->
        <div class="dataup">
          <!-- 数据总览 -->
          <div class="dataView" :data="UnveilingList">
            <h4>数据总览</h4>
            <div class="r-data">
              <div class="r-topData">
                <p>技术成果库</p>
                <p class="num">{{ UnveilingList.AchievementsCnt }}</p>
              </div>
              <div class="r-botData">
                <p class="nation">
                  <span style="font-weight: bold">国内（项）</span>
                  <span class="numb">{{
                    UnveilingList.InAchievementsCnt
                  }}</span>
                </p>
                <p class="nation">
                  <span style="font-weight: bold"> 国外（项）</span
                  ><span class="numb">{{
                    UnveilingList.OutAchievementsCnt
                  }}</span>
                </p>
              </div>
            </div>
            <div class="d-data">
              <p>技术需求库</p>
              <p class="num">{{ UnveilingList.DemandCnt }}</p>
            </div>
            <div class="h-data">
              <p>高层次人才征集</p>
              <p class="num">{{ UnveilingList.PersonCnt }}</p>
            </div>
            <div class="m-data">
              <div class="m-topData">
                <p class="m-topDataLeft">机构库</p>
                <!-- 没字段 -->
                <p class="num">{{ UnveilingList.OrganizationAll }}</p>
                <!-- <p class="num">{{UnveilingList.PersonCnt}}</p> -->
              </div>
              <div class="m-botData">
                <div class="firstLi">
                  <p class="nation">
                    <span style="font-weight: bold">国内</span
                    ><span class="numb">{{ UnveilingList.CN }}</span>
                  </p>
                  <p class="nation">
                    <span style="font-weight: bold">国外</span
                    ><span class="numb">{{ UnveilingList.EN }}</span>
                  </p>
                </div>
                <ul>
                  <!-- <li> -->
                  <!-- <p>河南省技术创新中心</p> -->
                  <!-- 没字段 -->
                  <!-- <p class="numb">{{}}</p> -->
                  <!-- <p class="numb">{{UnveilingList.EN}}</p> -->
                  <!-- </li> -->
                  <li>
                    <p>河南省新型研发机构</p>
                    <p class="numb">{{ UnveilingList.Organization }}</p>
                  </li>
                  <li>
                    <p>河南省技术转移示范机构</p>
                    <p class="numb">
                      {{ UnveilingList.TechnologyOrganization }}
                    </p>
                  </li>
                  <li>
                    <p>河南省产业技术创新战略联盟</p>
                    <p class="numb">{{ UnveilingList.UnionOrganization }}</p>
                  </li>
                  <li>
                    <p>国际技术转移机构</p>
                    <!-- 没字段 -->
                    <p class="numb">{{ UnveilingList.EN }}</p>
                    <!-- <p class="numb">{{UnveilingList.Organization}}</p> -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 技术领域展示 -->
          <div class="TechView">
            <h4>技术领域展示</h4>
            <div class="charts">
              <!-- <p :data="HistogramList[0]">{{ HistogramList[0].name }}</p> -->
              <div class="FirstChart" style="width: 150.4px;" >
                <charts-0 ref="FirstChart"></charts-0>
              </div>

              <div class="FirstChart1">
                <charts-1 ref="FirstChart1"></charts-1>
              </div>

              <div class="FirstChart2">
                <charts-2 ref="FirstChart2"></charts-2>
              </div>

              <div class="FirstChart3">
                <charts-3 ref="FirstChart3"></charts-3>
              </div>

              <div class="FirstChart4">
                <charts-4 ref="FirstChart4"></charts-4>
              </div>

              <div class="FirstChart5">
                <charts-5 ref="FirstChart5"></charts-5>
              </div>

              <div class="FirstChart5">
                <charts-6 ref="FirstChart6"></charts-6>
              </div>

              <div class="FirstChart5">
                <charts-7 ref="FirstChart7"></charts-7>
              </div>

              <div class="FirstChart5">
                <charts-8 ref="FirstChart8"></charts-8>
              </div>

              <div class="FirstChart5">
                <charts-9 ref="FirstChart9"></charts-9>
              </div>
            </div>
          </div>
        </div>
        <!-- 数据下 -->
        <div class="datadown">
          <div class="dataL">
            <!-- 云展厅 -->
            <div class="cloudShow">
              <h4>云展厅</h4>
              <ul>
                <li v-for="(i, n) in cloudShowList" :key="n">
                  <p class="valueTop">{{ i.value }}</p>
                  <p class="valueDown">{{ i.key }}</p>
                </li>
              </ul>
            </div>
            <!-- 揭榜挂帅 -->
            <div class="Unveiling">
              <h4>揭榜挂帅</h4>
              <div class="Unveiling-down" :data="UnveilingList">
                <div class="notice">
                  <p class="imgcontain">
                    <img src="../assets/Home/组 23261@2x.png" alt="" />
                  </p>
                  <div class="n-right">
                    <p class="n-right-title">张榜项目</p>
                    <div class="n-right-down">
                      <p class="AchievementL">
                        成果转化类</br><span>{{ UnveilingList.ZBCG }}</span
                        >项
                      </p>
                      <p class="AchievementL">
                        技术攻关类</br><span>{{ UnveilingList.ZBJS }}</span
                        >项
                      </p>
                    </div>
                  </div>
                </div>
                <div class="contract">
                  <p class="imgcontain">
                    <img src="../assets/Home/组 23461@2x.png" alt="" />
                  </p>
                  <div class="n-right">
                    <p class="n-right-title">签约项目</p>
                    <div class="n-right-down">
                      <p>
                        成功签约</br><span>{{ UnveilingList.ZBQY }}</span
                        >项
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 合同登记 -->
          <div class="dataR">
            <h4>河南省技术合同登记统计</h4>
            <div class="dataR-down">
              <div class="Turnover">
                <p>2020年河南省技术合同成交额</p>
                <p><span>384.5</span>亿元</p>
              </div>
              <!-- 合同的图 -->
              <charts-10></charts-10>
            </div>
          </div>
        </div>
      </div>
      <!-- 项目对接统计 -->
      <div class="project">
        <h3>项目对接统计</h3>
        <p>PROJECT DOCKING STATISTICS</p>
        <div class="Classification">
          <ul class="ul1">
            <li
              v-for="(item, n) in NoticeTab"
              :key="n"
              :class="TabIndex == n ? 'focusTab' : ''"
              :data-index="n"
              @click="ChangeTab(n)"  style="cursor: pointer;"
            >
              {{ item }}
              <span v-if="n === 0">( {{ DockingNum.AllCnt }})</span>
              <span v-if="n === 1">({{ DockingNum.DJCnt }})</span>
              <span v-if="n === 2">({{ DockingNum.QTCnt }})</span>
              <span v-if="n === 3">({{ DockingNum.HZCnt }})</span>
            </li>
          </ul>
          <div>
            <ul class="ul2">
              <li v-for="(i, n) in ProList" :key="n">
                <div>
                  <img :src="i.img" alt="" />
                </div>
                <div class="">
                  <p>
                    <span>{{ i.num }}</span
                    >个
                  </p>
                  <p>{{ i.title }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChinaMap from "../components/ChinaMap.vue";
import HeNanMap from "../components/HeNanMap";
import { AllDataNum, dockingList, TypeList, cloudSelect } from "../api/url";
import { getAction, postAction } from "../api/api";
import Charts1 from "./echarts/charts1.vue";
import Charts2 from "./echarts/charts2.vue";
import Charts3 from "./echarts/charts3.vue";
import Charts4 from "./echarts/charts4.vue";
import Charts5 from "./echarts/charts5.vue";
import Charts6 from "./echarts/charts6.vue";
import Charts7 from "./echarts/charts7.vue";
import Charts8 from "./echarts/charts8.vue";
import Charts9 from "./echarts/charts9.vue";
import Charts0 from "./echarts/charts0.vue";
import Charts10 from "./echarts/charts10.vue";
export default {
  components: {
    ChinaMap,
    HeNanMap,
    Charts1,
    Charts2,
    Charts4,
    Charts5,
    Charts3,
    Charts6,
    Charts7,
    Charts8,
    Charts9,
    Charts0,
    Charts10,
  },
  data() {
    return {
      MapActive: 0,
      MsgNumList: {},
      NoticeTab: ["全部", "线上对接", "达成意向", "合作签约"],
      TabIndex: 0,
      ProList: [
        {
          title: "高端装备制造",
          img: require("../assets/Home/组 23180@2x.png"),
          num: 2,
        },

        {
          title: "新型材料",
          img: require("../assets/Home/组 23180@2x(1).png"),
          num: 2,
        },
        {
          title: "新一代信息技术",
          img: require("../assets/Home/组 23180@2x(2).png"),
          num: 2,
        },
        {
          title: "现代农业",
          img: require("../assets/Home/组 23180@2x(4).png"),
          num: 2,
        },
        {
          title: "新能源及新能源汽车",
          img: require("../assets/Home/组 23180@2x(3).png"),
          num: 2,
        },

        {
          title: "食品工业",
          img: require("../assets/Home/组 23180@2x(5).png"),
          num: 2,
        },
        {
          title: "生物医药及健康",
          img: require("../assets/Home/组 23180@2x(6).png"),
          num: 2,
        },
        {
          title: "节能环保",
          img: require("../assets/Home/组 23180@2x(7).png"),
          num: 2,
        },
        {
          title: "公共安全和应急处置",
          img: require("../assets/Home/组 23180@2x(8).png"),
          num: 2,
        },
        {
          title: "其他",
          img: require("../assets/Home/组 23180@2x(9).png"),
          num: 2,
        },
      ],
      DockingNum: {},
      cloudShowList: [
        {
          key: "参展单位",
          value: 0,
        },
        {
          key: "参展项目",
          value: 0,
        },
        {
          key: "成果厅",
          value: 0,
        },
        {
          key: "需求厅",
          value: 0,
        },
        {
          key: "云路演",
          value: 0,
        },
      ],
      UnveilingList: {},
      HistogramList: [],
      AllDataNum: [],
    };
  },
  created() {
    this.loadLeaveMsgTotal();
    this.loadCategory();
    this.loadTechField();
    this.loadTechFieldNum(0);
    this.loadCloud();
    this.loadHistogram();
    this.loadUnveiling();
  },
  mounted() {
    // setTimeout(() => {
    //   let mc10=document.querySelector('#myChart10')
    //   this.drawLine();
    // }, 500);
  },
  beforeDestroy() {
    this.$refs.StopInter.Stop();
  },
  methods: {
    loadCategory() {
      let data = {
        action: "Get_Category",
      };
      getAction(AllDataNum, data).then((res) => {
        //// console.log(res);
        this.AllDataNum = res;
      });
    },
    loadCloud() {
      //云展厅统计
      let data = {
        action: "Get_Count",
      };
      getAction(cloudSelect, data).then((res) => {
        //// console.log('"云展厅统计"', res);
        this.cloudShowList[0].value = res[0].参展单位;
        this.cloudShowList[1].value = res[0].参展项目;
        this.cloudShowList[2].value = res[0].成果厅;
        this.cloudShowList[3].value = res[0].需求厅;
        this.cloudShowList[4].value = res[0].云路演;
      });
    },
    loadUnveiling() {
      //数据总览,揭榜挂帅统计
      let data = {
        action: "GetBasicStatistics",
      };
      getAction(AllDataNum, data).then((res) => {
        //// console.log("揭榜挂帅统计", res[0]);
        // //// console.log(111)
        this.UnveilingList = res[0];
      });
    },
    loadHistogram() {
      // 技术领域展示
      let data = {
        action: "GetHistogram",
      };
      getAction(AllDataNum, data).then((res) => {
        //// console.log("技术领域展示", res);
        this.HistogramList = res;
        //// console.log(111);
        this.$refs.FirstChart.startCharts(this.HistogramList[0]);
        this.$refs.FirstChart1.startCharts(this.HistogramList[4]);
        this.$refs.FirstChart2.startCharts(this.HistogramList[1]);
        this.$refs.FirstChart3.startCharts(this.HistogramList[5]);
        this.$refs.FirstChart4.startCharts(this.HistogramList[2]);
        this.$refs.FirstChart5.startCharts(this.HistogramList[7]);
        this.$refs.FirstChart6.startCharts(this.HistogramList[6]);
        this.$refs.FirstChart7.startCharts(this.HistogramList[3]);
        this.$refs.FirstChart8.startCharts(this.HistogramList[8]);
        this.$refs.FirstChart9.startCharts(this.HistogramList[9]);
      });
    },
    loadTechField() {
      let data = {
        action: "Get_TechFieldTotalCnt",
      };
      postAction(dockingList, this.$qs.stringify(data)).then((res) => {
        //// console.log(res);
        this.DockingNum = res;
      });
    },
    loadTechFieldNum(n) {
      let datas = {
        action: "Get_TechFieldTotal",
        status: n == 0 ? "" : n,
      };
      postAction(TypeList, this.$qs.stringify(datas)).then((res) => {
        for (var i = 0; i < res.length; i++) {
          this.ProList[i].num = res[i].Cnt;
        }
      });
    },
    changeMapActive(n) {
      this.MapActive = n;
      if (n == 0) {
        this.$refs.StopInter.Stop();
      } else {
        this.$refs.StopInter.ResetData();
      }
    },
    loadLeaveMsgTotal() {
      let data = {
        action: "GetBasicStatistics",
      };
      postAction(AllDataNum, this.$qs.stringify(data)).then((res) => {
        this.MsgNumList = res[0];
      });
    },
    ChangeTab(n) {
      // //// console.log(e)
      this.TabIndex = n;
      this.loadTechFieldNum(n);
    },
  },
};
</script>

<style lang="scss" scoped>
h4 {
  margin: 1.875rem 0;
}
.BG {
  background: url("../assets/Home/组 23358@2x.png");
  background-size: 100% 100%;
  height: 55.4375rem;
}
.Header {
  height: 8.875rem;
  padding-top: 2.875rem;
  margin-bottom: 4.125rem;
  ul {
    display: flex;
    width: 50rem;
    justify-content: space-between;
    align-items: center;
    li {
      div {
        font-size: 2rem;
        font-family: DIN-Bold;

        color: #2769dc;
        span {
          font-size: 0.875rem;
          color: #999;
          display: inline;
        }
      }
      span {
        font-size: 1rem;
        font-family: SourceHanSansCN-Regular;
        margin: 0.625rem 0 1.25rem;
        display: inline-block;
        color: #999999;
      }
      img {
        width: 7rem;
      }
    }
  }
  .manType {
    border-left: 1px solid #d7e1f1;
    p {
      display: inline-block;
      width: 2.875rem;
      height: 5.5rem;
      font-size: 1.375rem;
      font-family: SourceHanSansCN-Bold;
      line-height: 1.625rem;
      color: #2769dc;
      vertical-align: middle;
      opacity: 1;
      font-weight: bold;
      margin: 0 3.125rem;
    }

    .TypeBox {
      width: 24.375rem;
    }
    div {
      display: inline-block;
      vertical-align: middle;
      div {
        width: 10.875rem;
        height: 2.5rem;
        background: #ffffff;
        border: 1px solid rgba(180, 180, 180, 0.4);
        line-height: 2.5rem;
        border-radius: 0.625rem;
        font-size: 0.9375rem;
        font-family: SourceHanSansCN-Regular;
        text-align: left;
        color: #333333;
        margin-top: 0.75rem;

        box-sizing: border-box;
        padding: 0 1.25rem 0 0.625rem;

        strong {
          color: #2769dc;
          font-size: 1.3125rem;
          font-family: DIN-Bold;
          float: right;
        }
      }
    }
  }
}
.TheMap {
  h3 {
    font-size: 2.375rem;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 2.9375rem;
    color: #333333;
    position: relative;
  }
  h3::after {
    bottom: -3px;
    left: 0;
    position: absolute;
    width: 9.25rem;
    height: 0.5rem;
    background: linear-gradient(90deg, #2769dc 0%, #ffffff 100%);
    right: 0;
    margin: auto;
    clear: both;
    content: "";
  }
  p {
    font-size: 0.875rem;
    font-family: PingFang SC;
    font-weight: bold;
    margin-top: 0.625rem;
    color: #999999;
  }
  div {
    height: 3.25rem;
    font-size: 1rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 3.25rem;

    color: #333333;
    .China {
      display: inline-block;
      width: 11.25rem;
      border-radius: 1.625rem 0 0 1.625rem;
      background: linear-gradient(308deg, #ffffff 0%, #f8fbff 100%);
      box-sizing: border-box;
      border: 1px solid #b8c1d2;
      border-right: none;
    }
    .HeNan {
      display: inline-block;
      width: 11.25rem;
      border-radius: 0 1.625rem 1.625rem 0;
      box-sizing: border-box;
      border-left: none;
      border: 1px solid #b8c1d2;
      background: linear-gradient(308deg, #ffffff 0%, #f8fbff 100%);
    }
    .NowMapAct {
      background: linear-gradient(
        135deg,
        #0561d2 0%,
        #276adc 36%,
        #15abeb 100%
      );
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fff;
    }
    .NowMapActs {
      background: linear-gradient(
        225deg,
        #0561d2 0%,
        #276adc 36%,
        #15abeb 100%
      );
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fff;
    }
  }
}

.TheData {
  width: 87.5rem;
  font-size: 1rem;
  margin: 0 auto;
  h3 {
    font-size: 2.375rem;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 2.9375rem;
    color: #333333;
    position: relative;
  }
  h3::after {
    bottom: -3px;
    left: 0;
    position: absolute;
    width: 9.25rem;
    height: 0.5rem;
    background: linear-gradient(90deg, #2769dc 0%, #ffffff 100%);
    right: 0;
    margin: auto;
    clear: both;
    content: "";
  }
  p {
    font-size: 0.875rem;
    font-family: PingFang SC;
    font-weight: bold;
    margin-top: 0.625rem;
    margin-bottom: 2rem;
    color: #999999;
  }

  .nation {
    display: flex;
    justify-content: space-between;
    width: 9.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
    background-color: #ffffff;
    color: #333333;
    font-weight: bold;
    font-size: 0.8125rem;
    border-radius: 0.625rem;
    margin-left: 1.25rem;
    margin-right: 0.625rem;
    padding: 0 0.625rem;
    font-family: SourceHanSansCN-Regular;
    .numb {
      font-weight: 700;
      color: #2769dc;
      font-size: 1rem;
    }
  }
  .dataup {
    display: flex;
    justify-content: space-around;
    h4 {
      padding-left: 2.25rem;
      float: left;
      font-size: 1.875rem;
      position: relative;
      margin: 1.875rem 0;
    }
    h4::before {
      position: absolute;
      top: 0.5625rem;
      left: 0rem;
      content: "";
      clear: both;
      width: 1.5rem;
      height: 1.5rem;
      background: url("../assets/Home/组 23250.png") no-repeat center;
    }
    .dataView {
      width: 26.125rem;
      /* height: 31.25rem; */
      /* margin-right: 1.75rem; */
      div {
        overflow: hidden;
        /* width: 100%; */
        margin-bottom: 0.875rem;
        background-size: cover;
      }
      .r-data {
        clear: both;
        height: 9.4rem;
        background: url("../assets/Home/组 23462.png") no-repeat 0 0;
        background-size: 100%;
        p {
          margin-bottom: 0.625rem;
        }
        div {
          display: flex;
          justify-content: space-between;
        }
        .r-topData {
          width: 20.5rem;
          height: 4.125rem;
          line-height: 3.125rem;
          padding: 0 3.75rem;

          margin-top: 0.6rem;
          p {
            font-size: 1.25rem;
            color: #2769dc;
          }
          .num {
            font-size: 1.75rem;
          }
        }
        .r-botData {
          justify-content: start;
          margin-top: -0.9375rem;
        }
      }
      .d-data {
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        padding: 0 3.75rem;
        height: 5.5625rem;
        line-height: 1.625rem;
        background: url("../assets/Home/组 23465.png") no-repeat 0 0;
        background-size: 100%;
        p {
          margin-top: 1.95rem;
          font-size: 1.25rem;
          color: #f8870b;
        }
        .num {
          font-size: 1.75rem;
        }
      }
      .h-data {
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        /* width: 87%; */
        padding: 0 3.75rem;
        height: 5.5625rem;
        line-height: 1.625rem;
        background: url("../assets/Home/组 23468.png") no-repeat 0 0;
        background-size: 100%;
        p {
          margin-top: 1.9rem;
          font-size: 1.25rem;
          color: #16c4b2;
        }
        .num {
          font-size: 1.75rem;
        }
      }
      .m-data {
        overflow: hidden;
        height: 25.2rem;
        background: url("../assets/Home/组 23240.png") no-repeat 0 0;
        background-size: 100%;
        .m-topData {
          width: 20.2rem;
          margin-top: 0.7rem;
          margin-bottom: -1.5rem;
          line-height: 3.125rem;
          display: flex;
          justify-content: space-between;
          /* width: 77%; */
          padding: 0 3.75rem;
          /* .m-topDataLeft{
            margin-right: 6.8125rem;
          } */
          p {
            font-size: 1.25rem;
            color: #3950ff;
          }
          .num {
            font-size: 1.75rem;
          }
        }
        .m-botData {
          li {
            width: 22.25rem;
            height: 2.5rem;
            border-radius: 0.625rem;
            display: flex;
            background-color: #ffffff;
            margin-bottom: 0.625rem;
            margin-left: 1.25rem;
            color: #333333;
            padding: 0 0.625rem;
            justify-content: space-between;
            p {
              color: #333333;
            }
            .numb {
              color: #2769dc;
              font-size: 1rem;
            }
          }
          .firstLi {
            display: flex;
            margin-bottom: -1.1875rem;
            justify-content: flex-start;
          }
        }
      }
    }
    .TechView {
      width: 60.25rem;

      .charts {
        overflow: hidden;
        clear: both;
        display: flex;
        flex-wrap: wrap;
        .FirstChart5 {
          margin-top: 5.375rem;
        }
      }
    }
  }
  .datadown {
    display: flex;

    h4 {
      padding-left: 2.25rem;
      font-size: 1.875rem;
      position: relative;
    }
    h4::before {
      position: absolute;
      top: 0.5625rem;
      left: 0rem;
      content: "";
      clear: both;
      width: 1.5rem;
      height: 1.5rem;
      background: url("../assets/Home/组 23250.png") no-repeat center;
    }
    .dataL {
      /* width: 43.75rem; */
      .cloudShow {
        display: flex;
        flex-direction: column;
        h4 {
          text-align: left;
        }
        ul {
          display: flex;
        }
        li {
          width: 8.125rem;

          /* height: 5.25rem; */
          margin-right: 0.75rem;
          background: #ffffff;
          box-shadow: 0px 0.1875rem 0.625rem rgba(0, 0, 0, 0.08);
          opacity: 1;
          border-radius: 0.375rem;
          .valueTop {
            font-size: 1.625rem;
            font-family: DIN-Bold;
            color: #2769dc;
            margin-top: 1.0625rem;
            margin-bottom: 0.375rem;
          }
          .valueDown {
            font-size: 0.875rem;
            font-family: SourceHanSansCN-Regular;
            color: #999999;
            margin-bottom: 1rem;
          }
        }
      }
      .Unveiling {
        height: 13.8125rem;
        display: flex;
        flex-direction: column;
        h4 {
          // margin-top: 3rem;
          text-align: left;
        }
        .Unveiling-down {
          display: flex;
          .imgcontain {
            margin: 1.625rem 1.0625rem 1.625rem 1.5625rem;
          }
          img {
            width: 4.1875rem;
          }

          .n-right {
            .n-right-title {
              margin-top: 1.625rem;
              font-size: 1.5625rem;
              font-family: SourceHanSansCN-Medium;
              line-height: 1.75rem;
              color: #333333;
              text-align: left;
              margin-bottom: 0.75rem;
            }
            .n-right-down {
              display: flex;
              .AchievementL {
                margin-right: 0.7rem;
              }
              p {
                text-align: center;
                box-sizing: border-box;
                padding: 0.5rem 0.625rem 0.375rem;
                width: 7.75rem;
                font-size: .75rem;
                /* line-height: 1.75rem; */
                background: #f3f3f3;
                opacity: 1;
                border-radius: 0.875rem;
                margin-top: 0;
				
				@media screen and (max-width: 1366px){
					width: 8rem;
				}
                span {
                  display: inline-block;
                  padding: 0 0.1875rem;
                  font-size: 1.125rem;
                  font-family: DIN-Bold;
                  /* line-height: 0.8125rem; */
                  color: rgba(39, 105, 220, 1);
                }
              }
            }
          }

          .notice {
            display: flex;
            width: 25rem;
            /* height: 7.4375rem; */
            background: #ffffff;
            box-shadow: 0px 0.1875rem 1.25rem rgba(0, 0, 0, 0.08);
            opacity: 1;
            border-radius: 0.375rem;
            margin-right: 0.625rem;
            /* background: lightsalmon; */
			@media screen and (max-width : 1366px ) {
				width : 25rem;
			}
          }
          .contract {
            display: flex;
            width: 16.5rem;
            /* height: 7.4375rem; */
            background: #ffffff;
            box-shadow: 0px 0.1875rem 1.25rem rgba(0, 0, 0, 0.08);
            opacity: 1;
            border-radius: 0.375rem;
            padding-right: 1.5rem;
            /* background-color: lime; */
          }
        }
      }
    }
    .dataR {
      /* overflow: hidden; */
      width: 41.875rem;

      h4 {
        text-align: left;
      }
      .dataR-down {
        /* width: 41.875rem; */
        padding: 1.6875rem 1.25rem 2.125rem 1.25rem;
        /* height: 15.1875rem; */
        background: #ffffff;
        box-shadow: 0px 0.1875rem 1.25rem rgba(0, 0, 0, 0.08);
        opacity: 1;
        border-radius: 0.375rem;
        .Turnover {
          display: flex;
          justify-content: space-between;
          width: 39.375rem;
          height: 2.875rem;
          /* background: #9FA3B3; */
          background: #f3f3f3;
          /* opacity: 0.4; */
          border-radius: 0.625rem;
          margin-bottom: 3.5rem;

          p {
            line-height: 2.875rem;
            font-size: 0.9375rem;
            font-weight: normal;
            font-family: SourceHanSansCN-Regular;
            color: #333333;
            opacity: 1;
            margin-top: 0;
            margin-left: 1.25rem;
            margin-right: 1.25rem;
            span {
              font-size: 1.3125rem;
              font-family: DIN-Bold;
              /* line-height: 48px; */
              font-weight: bold;
              color: #2769dc;
              opacity: 1;
              line-height: 2.875rem;
              margin-right: 0.6875rem;
            }
          }
        }
      }
    }
  }
}
.project {
  width: 87.5rem;
  font-size: 1rem;
  margin: 0 auto;
  margin-top: 5.75rem;
  /* margin: 20.25rem; */
  .Classification {
    margin-bottom: 1.875rem;
    .ul1 {
      display: flex;
      justify-content: space-between;
      li {
        width: 21.5625rem;
        height: 5.5rem;
        line-height: 5.5rem;
        background: linear-gradient(
          134deg,
          rgba(59, 74, 129, 0.16) 0%,
          rgba(131, 154, 200, 0.16) 100%
        );
        box-shadow: -0.125rem 0.125rem 2.1875rem rgba(14, 13, 61, 0.06);
        border-radius: 0px;
        font-size: 1.5rem;
        color: #686f88;
        margin-right: 0.4375rem;
      }
      li:last-child {
        margin-right: 0;
      }
      .focusTab {
        border: 0.0625rem solid rgba(0, 0, 0, 0);
        background: linear-gradient(
          136deg,
          #0561d2 0%,
          #276adc 36%,
          #15abeb 100%
        );
        box-shadow: -0.125rem 0.125rem 2.1875rem rgba(14, 13, 61, 0.06);
        border-radius: 0.375rem 0.375rem 0px 0px;
        font-size: 1.5rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 5.5rem;
        color: #ffffff;
        position: relative;
      }
      .focusTab::after {
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        bottom: -1.4rem;
        content: "";
        width: 1.375rem;
        height: 1.25rem;
        box-sizing: border-box;
        border-image-source: border-box;
        border-top: 1.375rem solid #316fda;

        border-left: 1.25rem solid transparent;

        /* border-image: linear-gradient(136deg, #0561D2 0%, #276ADC 36%, #15ABEB 100%); */
        pointer-events: none;
        border-right: 1.25rem solid transparent;
      }
    }
    .ul2 {
      box-shadow: 0px 3px 1.25rem rgba(0, 0, 0, 0.08);
      background: #ffffff;
      margin-bottom: 6.25rem;
      padding-bottom: 3.125rem;
      display: flex;
      flex-wrap: wrap;
      li {
        width: 11rem;
        display: flex;
        margin-top: 3.125rem;
        margin-left: 3.125rem;
        margin-right: 3.375rem;
        text-align: left;
        img {
          width: 3.75rem;
          height: 100%;
          margin-right: 1.25rem;
        }
        p {
          /* width: 9rem; */
          font-weight: normal;
          font-size: 1rem;
          font-family: SourceHanSansCN-Regular;
          color: #999999;
          margin: 0 0.625rem 0 0;
          white-space: nowrap;
          span {
            font-size: 2rem;
            color: #333333;
            font-family: SourceHanSansCN-Regular;
          }
        }
      }
    }
  }
  h3 {
    font-size: 2.375rem;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 2.9375rem;
    color: #333333;
    position: relative;
  }
  h3::after {
    bottom: -3px;
    left: -3.8125rem;
    position: absolute;
    width: 9.25rem;
    height: 0.5rem;
    background: linear-gradient(90deg, #2769dc 0%, #ffffff 100%);
    right: 0;
    margin: auto;
    clear: both;
    content: "";
  }
  p {
    font-size: 0.875rem;
    font-family: PingFang SC;
    font-weight: bold;
    margin-top: 0.625rem;
    color: #999999;
    margin-bottom: 3.8125rem;
  }
}
/deep/.el-descriptions-item__content {
  display: flex;
  justify-content: space-around;
  span {
    display: inline-block;
    text-align: center;
  }
}
</style>